/* eslint-disable one-var */
interface IMatches {
  start: number;
  end: number;
}

export interface IMatchDetails {
  text: string;
  isSymbol: boolean;
}

// eslint-disable-next-line max-lines-per-function
export const splitSymbols = (text: string, regexp: RegExp = /[©️®™·*]/g): IMatchDetails[] => {
  let foundMatch: RegExpExecArray | null;
  let matches: IMatches[] = [];
  let splitString: IMatchDetails[] = [];

  while ((foundMatch = regexp.exec(text)) !== null) {
    matches = [...matches, { start: foundMatch.index, end: regexp.lastIndex }];
  }

  if (matches.length === 0) {
    return [{ text, isSymbol: false }];
  }

  // First match is not the first character
  if (matches[0].start !== 0) {
    splitString = [
      {
        text: text.substring(0, matches[0].start),
        isSymbol: false,
      },
    ];
  }

  matches.forEach((match, index) => {
    splitString = [
      ...splitString,
      {
        text: text.substring(match.start, match.end),
        isSymbol: true,
      },
    ];

    if (matches[index + 1]) {
      splitString = [
        ...splitString,
        {
          text: text.substring(match.end, matches[index + 1].start),
          isSymbol: false,
        },
      ];
    }
  });

  if (matches[matches.length - 1].end !== text.length) {
    splitString = [
      ...splitString,
      {
        text: text.substring(matches[matches.length - 1].end, text.length),
        isSymbol: false,
      },
    ];
  }

  return splitString;
};
